import { useAuth } from '@/contexts/AuthContext';

/**
 * Kullanıcı yetkileri ve sayfa erişim kontrolü için hook
 */
export function usePermissions() {
  const { user } = useAuth();
  
  // Kullanıcının belirli bir sayfaya erişimi var mı?
  const canAccessPage = (pageId) => {
    if (!user) return false;
    if (user.role === 'super_admin') return true;
    return user.accessible_pages?.includes(pageId) || false;
  };
  
  // Kullanıcının belirli bir yetkisi var mı?
  const hasPermission = (category, permission) => {
    if (!user) return false;
    if (user.role === 'super_admin') return true;
    return user.detailed_permissions?.[category]?.[permission] === true;
  };
  
  // Kullanıcının erişebildiği sayfalar listesi
  const accessiblePages = user?.accessible_pages || [];
  
  // Kullanıcı yönetici mi?
  const isManager = ['super_admin', 'manager', 'sales_manager', 'customer_relations_manager'].includes(user?.role);
  
  // Kullanıcı süper admin mi?
  const isSuperAdmin = user?.role === 'super_admin';
  
  return {
    user,
    canAccessPage,
    hasPermission,
    accessiblePages,
    isManager,
    isSuperAdmin
  };
}

export default usePermissions;
